import { Action } from 'redux';

// Triggers
// undo
export const UNDO_TOAST_UNDO = 'UNDO_TOAST_UNDO';

interface UndoToastBaseAction extends Action {
    readonly id: string;
}

export interface UndoToastUndoAction extends UndoToastBaseAction {
    readonly type: typeof UNDO_TOAST_UNDO;
}

export const undoToastUndo = (id: string): UndoToastUndoAction => ({ type: UNDO_TOAST_UNDO, id });

export const UNDO_TOAST_SHOW = 'UNDO_TOAST_SHOW';

export interface UndoToastShowAction extends UndoToastBaseAction {
    readonly type: typeof UNDO_TOAST_SHOW;
    readonly message: string;
}

export const undoToastShow = (id: string, message: string): UndoToastShowAction => ({ type: UNDO_TOAST_SHOW, id, message });

export const UNDO_TOAST_HIDE = 'UNDO_TOAST_HIDE';

export interface UndoToastHideAction extends UndoToastBaseAction {
    readonly type: typeof UNDO_TOAST_HIDE;
}

export const undoToastHide = (id: string): UndoToastHideAction => ({ type: UNDO_TOAST_HIDE, id });

export const UNDO_TOAST_HIDDEN = 'UNDO_TOAST_HIDDEN';

export interface UndoToastHiddenAction extends UndoToastBaseAction {
    readonly type: typeof UNDO_TOAST_HIDDEN;
}

export const undoToastHidden = (id: string): UndoToastHiddenAction => ({ type: UNDO_TOAST_HIDDEN, id });
